module.exports = __webpack_public_path__ + "4a4385ca29ae199e3171a923b7bb3e5e.jpg";